import Markdown from 'markdown-to-jsx'

import { configuration } from './configuration'

type Props = {
  content: string
  isLiveContent?: boolean
  isReference?: boolean
  messageId?: string
}

export const ReactMarkdown = ({ content, isLiveContent, isReference, messageId }: Props) => (
  <div className="markdown-container">
    <Markdown options={configuration({ isLiveContent, isReference, messageId })}>
      {content}
    </Markdown>
  </div>
)
